import { render, staticRenderFns } from "./Chinese.vue?vue&type=template&id=40319980&scoped=true&"
import script from "./Chinese.vue?vue&type=script&lang=js&"
export * from "./Chinese.vue?vue&type=script&lang=js&"
import style0 from "./Chinese.vue?vue&type=style&index=0&id=40319980&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40319980",
  null
  
)

component.options.__file = "Chinese.vue"
export default component.exports